import moment from "moment";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { TechnicianTripListing } from "../Technician/TechnicianTripListing";

export class ServiceView extends React.Component {
    constructor(props) {
        super(props);
        //var canEdit = props.initialSite.canEdit;
        //if (props.initialSite.id == 0) {
        //    canEdit = true;
        //}
        this.state = {
            canEdit: true
        }
    }

    renderEditButton() {
        if (this.state.canEdit) {
            return <button className="btn btn-primary float-right btn-edit-template" onClick={this.setEditMode.bind(this)}>Edit</button>;
        }
    }

    setEditMode() {
        if (this.props.onSetEditMode) {
            this.props.onSetEditMode();
        }
    }


    render() {
        var data = this.props.initialState;
        var startDate = data.startDate ? moment(data.startDate).format("DD/MM/YYYY") : "";
        var dueDate = data.dueDate ? moment(data.dueDate).format("DD/MM/YYYY") : "";        
        var documentLink = <div className="mt-2">
            <a href={`/api/servicejob/${data.id}/document`} target="_blank">Download Service Report</a>
        </div >;
        return (
            <div>
                <h2>Service Details</h2>
                <div className="col-12 d-flex" style={{ padding: "0px 0px 0px 0px" }}>
                <div className="col-5">
                        <div className="card card-body bg-light col-12" style={{ height: "fit-content" }}>
                            {/*{this.renderEditButton()}*/}
                            <h4><strong>{data.name}</strong></h4>
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-5" style={{ paddingBottom: "2px" }}><strong>Start Date:</strong></div><div className="col-7">{startDate}</div>
                                        <div className="col-5" style={{ paddingBottom: "2px" }}><strong>Due Date:</strong></div><div className="col-7">{dueDate}</div>
                                        <div className="col-5" style={{ paddingBottom: "2px" }}><strong>Status:</strong></div><div className="col-7">{data.workflowStatus}<br /> <br /></div>
                                        <div className="col-5" style={{ paddingBottom: "2px" }}><strong>Description:</strong></div><div className="col-7 pre-wrap" >{data.problemDescription} {documentLink}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="/services"><u>View all services</u></a>
                    </div>


                    <div className="col-7">
                        <div className="card card-body bg-white">
                            <div className="row">
                                <Tabs className="icon-tabs col-12 border-0" style={{ padding: "0px" }}>
                                    <TabList style={{ padding: "0px" }}>
                                        <Tab style={{ textAlign: "left", fontSize: "1.5rem", padding: "0px", color: "#212529" }}>Technician Trip</Tab>
                                    </TabList>
                                    <TabPanel style={{ padding: "0px" }} key={'technicianTrip-listing'}>
                                        <TechnicianTripListing limitToServiceJob={data} />
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}